import ContestsList from "../components/contests/ContestsList";
import { ApplicationWithId } from "../interfaces/IApplications";
import { Box } from "@mui/material";
import { ContestWithId } from "../interfaces/IContests";
import { getNewApplication } from "../utils/emptyObjects";
import { useApplicationsContext } from "../contexts/ApplicationsContext";
import { useContestsContext } from "../contexts/ContestsContext";
import { useMemo } from "react";
import { useNavigationHelper } from "../hooks/useNavigationHelper";
import { useUserContext } from "../contexts/UserContext";
import FlexBanner from "../components/shared/FlexBanner";

export default function Contests() {
  const { user } = useUserContext();
  const { contests } = useContestsContext();
  const { applications, handleApplicationAdd, handleApplicationDelete } = useApplicationsContext();
  const { goToApplicationDetails } = useNavigationHelper();

  // Podział zawodów na zbliżające się i zakończone
  const { upcomingContests, endedContests } = useMemo(() => {
    const now = new Date();

    const upcoming = contests.filter((contest) => {
      const endDate = new Date(contest.endDate);
      // Zawody są traktowane jako "zbliżające się", jeśli jeszcze się nie zakończyły
      // (czyli trwające obecnie lub przyszłe)
      return endDate >= now;
    });

    const ended = contests.filter((contest) => {
      const endDate = new Date(contest.endDate);
      // Zawody zakończone to te, których endDate jest w przeszłości
      return endDate < now;
    });

    return { upcomingContests: upcoming, endedContests: ended };
  }, [contests]);

  const addNewApplication = async (contest: ContestWithId) => {
    let application: ApplicationWithId | undefined;
    if (contest && user) {
      application = getNewApplication(contest, user);
    }
    if (application) {
      const result = await handleApplicationAdd(application);
      if (!result.success) {
        console.error("Błąd podczas tworzenia zgłoszenia:", result.error);
      }
    }
  };

  const handleEditApplication = (contestId: string, applicationId: string) => {
    goToApplicationDetails(contestId, applicationId);
  };

  const handleRemoveApplication = async (applicationId: string) => {
    const result = await handleApplicationDelete(applicationId);
    if (!result.success) {
      console.error("Błąd podczas usuwania zgłoszenia:", result.error);
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 4, mt: 2 }}>
      {/* Zbliżające się zawody */}
      <ContestsList
        contests={upcomingContests}
        applications={applications}
        title="Zbliżające się zawody"
        emptyMessage="Brak zbliżających się zawodów"
        onAddApplication={addNewApplication}
        onEditApplication={handleEditApplication}
        onRemoveApplication={handleRemoveApplication}
      />

      {/* Zakończone zawody */}
      <ContestsList
        contests={endedContests}
        applications={applications}
        title="Zakończone zawody"
        emptyMessage="Brak zakończonych zawodów"
        onAddApplication={addNewApplication}
        onEditApplication={handleEditApplication}
        onRemoveApplication={handleRemoveApplication}
      />

      {/* Baner Flex */}
      <FlexBanner variant="dashboard" />
    </Box>
  );
}
